var _templateObject, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgManga = function SvgManga(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cbc1e2",
    stroke: "currentColor",
    d: "M20 .5a9.48 9.48 0 0 1 6.559 2.63l.332.333.008.009 9.609 9.61.005.004.006.005A9.5 9.5 0 0 1 39.5 20v10a9.5 9.5 0 0 1-14.251 8.227l-.25-.145-.251.145A9.44 9.44 0 0 1 20 39.5a9.48 9.48 0 0 1-6.893-2.964l-.008-.01-9.609-9.608-.005-.006-.006-.005A9.48 9.48 0 0 1 .5 20V10a9.5 9.5 0 0 1 14.25-8.228l.25.145.251-.145A9.45 9.45 0 0 1 20 .5Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M30.488 29.284a1.56 1.56 0 0 1 1.783.969l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    fillRule: "evenodd",
    d: "M30.813 28a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#597e6f",
    d: "M10 5c2.761 0 5 2.303 5 5.143C15 7.303 17.239 5 20 5s5 1.286 5 1.286v15.428s-2.987-1.285-5-1.285c-1.85 0-3.465 1.034-4.33 2.571h-1.34c-.865-1.537-2.48-2.571-4.33-2.571-2.013 0-5 1.285-5 1.285V6.286S7.987 5 10 5"
  }))));
};
export default SvgManga;